export default "__VITE_ASSET__d8e1fbf9__"